export const CATEGORY_STYLE = {
  "Lead prioritaire": "bg-rose-100 text-rose-700",
  "Lead chaud": "bg-orange-100 text-orange-700",
  "Lead tiède": "bg-amber-100 text-amber-700",
  "Lead froid": "bg-sky-100 text-sky-700",
};

export const STATUS_STYLE = {
  "Test non terminé": "bg-amber-100 text-amber-700",
  "Nouveau lead": "bg-[#f0f2f8] text-[#1a2d56]",
  "À contacter": "bg-violet-100 text-violet-700",
  "Contacté": "bg-blue-100 text-blue-700",
  "Rendez-vous proposé": "bg-cyan-100 text-cyan-700",
  "Rendez-vous confirmé": "bg-teal-100 text-teal-700",
  "Présent au rendez-vous": "bg-emerald-100 text-emerald-700",
  "Inscrit": "bg-green-200 text-green-800",
  "Perdu": "bg-rose-100 text-rose-700",
  "À relancer plus tard": "bg-amber-100 text-amber-700",
  "Non qualifié": "bg-slate-200 text-slate-600",
};

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("fr-BE", { day: "2-digit", month: "short", year: "numeric" });
}
